// src/utils/updateMetaTags.js
export const updateMetaTags = (title, descriptions, keywords) => {
    document.title = title;
  
    let metaDescription = document.querySelector('meta[name="descriptions"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.name = "descriptions";
      document.head.appendChild(metaDescription);
    }
    metaDescription.content = descriptions;
  
    let metaKeywords = document.querySelector('meta[name="keywords"]');
    if (!metaKeywords) {
      metaKeywords = document.createElement('meta');
      metaKeywords.name = "keywords";
      document.head.appendChild(metaKeywords);
    }
    metaKeywords.content = keywords;
  
    let ogTitle = document.querySelector('meta[property="og:title"]');
    if (!ogTitle) {
      ogTitle = document.createElement('meta');
      ogTitle.setAttribute("property", "og:title");
      document.head.appendChild(ogTitle);
    }
    ogTitle.content = title;
  
    let ogDescription = document.querySelector('meta[property="og:descriptions"]');
    if (!ogDescription) {
      ogDescription = document.createElement('meta');
      ogDescription.setAttribute("property", "og:descriptions");
      document.head.appendChild(ogDescription);
    }
    ogDescription.content = descriptions;
  };
  